export const paymentActionTypes = {
    'GET_PAYMENT_ENTRY':"GET_PAYMENT_ENTRY",
    'SET_PAYMENT_ENTRY':"SET_PAYMENT_ENTRY"
}